import { AbridgedAsset } from 'store/assets/types';
import { SyncResponse as DataSyncResponse, SyncState } from 'store/sync/types';
import { createAction, createAsyncAction } from 'typesafe-actions';

// Background Loop

export const doSyncSetStatus =
  createAction('doSyncSetStatus')<
    Pick<SyncState['syncStatus'], 'step' | 'count'>
  >();

export const INIT_BG_LOOP = createAction('@SYNC/INIT_BG_LOOP')();

export const PAUSE_BG_NETWORK = createAction('@SYNC/PAUSE_BG_NETWORK')();
export const UNPAUSE_BG_NETWORK = createAction('@SYNC/UNPAUSE_BG_NETWORK')();

export const SET_SYNC_STATE = createAction('@SYNC/SET_SYNC_STATE')<
  Partial<SyncState>
>();

export const DOWNLOAD_ASSETS = createAction('@SYNC/DOWNLOAD_ASSETS')<
  string[]
>();

export const UPDATE_ASSET_LIST = createAction(
  '@SYNC/UPDATE_ASSET_LIST',
)<DataSyncResponse>();

export const UPDATE_ORGANISATION_LIST = createAction(
  '@SYNC/UPDATE_ORGANISATION_LIST',
)<DataSyncResponse>();

export const DO_MANUAL_SYNC = createAction('@SYNC/DO_MANUAL_SYNC')<{
  addAssetIds?: string[];
}>();

export const DO_AUTO_SYNC = createAction('@SYNC/DO_AUTO_SYNC')();

export const MANAGE_ASSET_FILE_DOWNLOADS = createAction(
  '@SYNC/MANAGE_ASSET_FILE_DOWNLOADS',
)<Record<string, AbridgedAsset>>();

export const ADD_FILE_TO_UPLOAD_QUEUE = createAction(
  '@SYNC/ADD_FILE_TO_UPLOAD_QUEUE',
)<string[]>();

export const doSetAppUpdateAvailable = createAction('doSetAppUpdateAvailable')<{
  status: false | 'minor' | 'major';
}>();

export const DATA_SYNC = createAsyncAction(
  '@SYNC/DATA_REQUEST',
  '@SYNC/DATA_RESPONSE',
  '@SYNC/DATA_FAILURE',
)<undefined, DataSyncResponse, Error>();

// THUMBNAIL DOWNLOAD

export const DOWNLOAD_THUMBNAILS = createAsyncAction(
  '@SYNC/THUMBNAILS_REQUEST',
  '@SYNC/THUMBNAILS_RESPONSE',
  '@SYNC/THUMBNAILS_FAILURE',
)<undefined, { id: string; width: number; height: number }[], Error>();

export const REMOVE_DOWNLOADED_THUMBNAILS = createAction(
  '@SYNC/REMOVE_DOWNLOADED_THUMBNAILS',
)<{
  assetId: string;
  fileIds: string[];
}>();

export const ADD_DOWNLOADED_THUMBNAIL = createAction(
  '@SYNC/ADD_DOWNLOADED_THUMBNAIL',
)<{
  assetId: string;
  fileId: string;
}>();

// FILES DOWNLOAD

export const DOWNLOAD_FILES = createAsyncAction(
  '@SYNC/DOWNLOAD_FILES.REQUEST',
  '@SYNC/DOWNLOAD_FILES.SUCCESS',
  '@SYNC/DOWNLOAD_FILES.FAIL',
)<undefined, string[], Error>();

export const REMOVE_DOWNLOADED_FILES = createAction(
  '@SYNC/REMOVE_DOWNLOADED_FILES',
)<{
  assetId: string;
  fileIds: string[];
}>();

// FILES UPLOAD

export const UPLOAD_FILE = createAsyncAction(
  '@SYNC/UPLOAD_FILES_REQUEST',
  '@SYNC/UPLOAD_FILES_RESPONSE',
  '@SYNC/UPLOAD_FILES_FAILURE',
)<string, string, Error>();

export const doSetFileUploadFailed = createAction('doSetFileUploadFailed')<{
  fileId: string;
}>();

export const DELETE_ASSETS = createAction('@SYNC/DELETE_ASSETS')<{
  ids: string[];
}>();
export const DELETE_ASSETS_WITH_CHANGE_CHECK = createAction(
  '@SYNC/DELETE_ASSETS_WITH_CHANGE_CHECK',
)<{
  ids: string[];
}>();
export const ASSETS_DELETED = createAction('@SYNC/ASSETS_DELETED')<{
  ids: string[];
}>();
export const DELETE_ORGANISATIONS = createAction('@SYNC/DELETE_ORGANISATIONS')<{
  ids: string[];
}>();
export const ORGANISATIONS_DELETED = createAction(
  '@SYNC/ORGANISATIONS_DELETED',
)<{
  ids: string[];
}>();
export const Q_DELETE_ASSETS = createAction('@SYNC/Q_DELETE_ASSETS')<{
  ids: string[];
}>();

export const CHECK_FOR_APP_UPDATE = createAction(
  '@SYNC/CHECK_FOR_APP_UPDATE',
)();

export const CHECK_FOR_APP_UPDATE_MANUAL = createAction(
  '@SYNC/CHECK_FOR_APP_UPDATE_MANUAL',
)();

export const CONFIRM_UPDATE_APP = createAction('@SYNC/CONFIRM_UPDATE_APP')();
export const SET_SYNCING_NONE = createAction('@SYNC/SET_SYNCING_NONE')();

export const UPLOAD_ERRORS = createAsyncAction(
  '@SYNC/UPLOAD_ERRORS_REQUEST',
  '@SYNC/UPLOAD_ERRORS_RESPONSE',
  '@SYNC/UPLOAD_ERRORS_FAILURE',
)<undefined, undefined, undefined>();
